import React, { ReactNode, FC } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import TopContainer from './AppBar/TopContainer';
import MenuContainer from './Navigation/MenuContainer';
import BodyContainer from './BodyContainer';
import NavigationContainer from './Navigation/NavigationContainer';
import AppBarContainer from './AppBar/AppBarContainer';
import Location from './Location';
import ConfirmProviderChangeContainer from '../ConfirmProviderChangeContainer';
import { useSelector } from 'react-redux';
import { RootStoreType } from 'src/types/store';

const DRAWER_WIDTH = 240;

type PropsType = {
    children: ReactNode;
    window?: () => Window;
};

const LayoutContainer: FC<PropsType> = (props) => {
    const { window, children } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const provider = useSelector((state: RootStoreType) => state.provider.data);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const container = window !== undefined ? () => window().document.body : undefined;
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <TopContainer draverWidth={DRAWER_WIDTH} handleDrawerToggle={handleDrawerToggle}>
                {/* todo: dodelat nazev routy/bloku, vyhledavani, a dalsi veci pre layout */}
                <AppBarContainer />
            </TopContainer>
            <MenuContainer
                draverWidth={DRAWER_WIDTH}
                handleDrawerToggle={handleDrawerToggle}
                mobileOpen={mobileOpen}
                container={container}
            >
                <NavigationContainer />
            </MenuContainer>
            <BodyContainer draverWidth={DRAWER_WIDTH}>{children}</BodyContainer>
            <Location />
            <ConfirmProviderChangeContainer provider={provider} />
            {/* <IssueReportLink /> */}
        </Box>
    );
};

export default LayoutContainer;
